{
  "appName": "SmartAss AI",
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "viewAll": "View All",
    "viewDetails": "View Details",
    "back": "Back",
    "next": "Next",
    "close": "Close",
    "confirm": "Confirm",
    "loading": "Loading...",
    "retry": "Retry"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "scheduled": "Scheduled",
    "confirmed": "Confirmed",
    "inProgress": "In Progress",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "noShow": "No Show",
    "pending": "Pending",
    "converted": "Converted"
  },
  "errors": {
    "somethingWentWrong": "Sorry, Something went wrong",
    "pageNotFound": "Page not found",
    "unauthorized": "Unauthorized access",
    "networkError": "Network error. Please try again.",
    "unknown": "Unknown error"
  },
  "table": {
    "client": "Client",
    "service": "Service",
    "time": "Time",
    "status": "Status",
    "location": "Location",
    "actions": "Actions",
    "source": "Source",
    "lastInteraction": "Last Interaction",
    "noData": "No data available"
  },
  "copyright": "© {{year}} SmartAss AI. All rights reserved.",
  "language": "Language",
  "or": "Or",
  "noContactInfo": "No contact info",
  "anonymous": "Anonymous",
  "tbd": "TBD",
  "signIn": "Sign In",
  "userMenu": {
    "adminPanel": "Admin Panel",
    "clientView": "Tenant view",
    "customerView": "Customer View",
    "manage": "Manage",
    "dashboard": "Dashboard",
    "home": "Home",
    "signOut": "Sign out",
    "signingOut": "Signing out...",
    "logoutSuccess": "Logged out successfully",
    "profile": "Profile",
    "switchOrganization": "Switch organization",
    "roleBadgeAdmin": "Administrator",
    "roleBadgeDeveloper": "Developer"
  },
  "ui": {
    "darkMode": {
      "dark": "Dark",
      "light": "Light",
      "switchToLight": "Switch to Light Mode",
      "switchToDark": "Switch to Dark Mode"
    },
    "autoRefresh": {
      "label": "Auto refresh",
      "lastUpdated": "Last: {{time}}",
      "on": "ON",
      "off": "OFF"
    },
    "adminClientSelector": {
      "view": "Tenant:",
      "selectClient": "Select client"
    },
    "adminCompanySelector": {
      "view": "Company:",
      "selectCompany": "Select company",
      "allCompanies": "All companies"
    },
    "adminCustomerSelector": {
      "view": "Customer:",
      "selectCustomer": "Select customer"
    },
    "sidebar": {
      "expandSidebar": "Expand sidebar",
      "collapseSidebar": "Collapse sidebar"
    },
    "tenantSelector": {
      "title": "Select Your Organization",
      "description": "Choose which organization you'd like to access:",
      "company": "Company",
      "tenant": "Tenant",
      "tenantLevel": "Tenant (organization)",
      "companyLevel": "Company (team)",
      "preferred": "Preferred",
      "loadingOrganizations": "Loading your organizations...",
      "noOrganizationsTitle": "No Organizations Found",
      "noOrganizationsDescription": "You don't have access to any organizations yet. Please contact your administrator.",
      "availableOrganizations": "Available Organizations ({{count}})",
      "organizationHint": "Select a tenant for broad access or a company for more specific access. Hierarchy: Tenant → Company.",
      "selectToContinue": "Select your organization to continue.",
      "cancel": "Cancel",
      "continue": "Continue",
      "switchError": "Failed to switch organization. Please try again."
    }
  },
  "speechToText": {
    "voiceInput": "Voice input",
    "stopVoiceInput": "Stop voice input",
    "listening": "Listening...",
    "permissionDenied": "Microphone access is required. Please allow access and try again.",
    "noSpeech": "No speech detected. Try again or type your message.",
    "unsupported": "Voice input not available in this browser"
  },
  "structuredNote": {
    "structureWithAi": "Structure with AI",
    "updateStructure": "Update AI Structure",
    "editNote": "Edit note",
    "originalNote": "Original Note",
    "structuredNote": "AI-Structured Note",
    "emptyStructured": "No structured content yet.",
    "addItem": "Add item",
    "addNextStep": "Add next step",
    "sections": {
      "keyTakeaways": "Key Takeaways / Notes",
      "agreementsDecisions": "Agreements / Decisions",
      "nextSteps": "Next Steps / Tasks"
    },
    "labels": {
      "responsible": "Responsible",
      "deadline": "Deadline"
    },
    "placeholders": {
      "keyTakeaway": "Enter a key takeaway...",
      "agreement": "Enter an agreement or decision...",
      "task": "Task",
      "responsible": "Responsible (optional)",
      "deadline": "Deadline (optional)"
    },
    "regenerateConfirm": {
      "title": "Replace structured note?",
      "message": "The AI-structured note contains manual changes. Generating a new structure may replace them. Do you want to continue?",
      "continue": "Continue"
    },
    "loading": {
      "title": "Structuring your note…",
      "description": "AI is organizing takeaways, decisions, and next steps. This may take a few seconds."
    },
    "errors": {
      "generic": "Failed to structure the note. Please try again."
    }
  },
  "tenantInviteModal": {
    "title": "Generate Registration Link",
    "description": "Select a role for the invite link. Users who register with this link will be assigned the selected role.",
    "roleLabel": "Role",
    "roleRequired": "Please select a role",
    "rolePlaceholder": "Select a role",
    "roleTooltip": "The role assigned to users who register using this link",
    "roleOwner": "Owner",
    "roleEmployee": "Employee",
    "generateLink": "Generate Link",
    "cancel": "Cancel",
    "close": "Close",
    "tokenSuccess": "Invite link generated",
    "tokenError": "Failed to generate invite link: {{error}}",
    "successTitle": "Invite link generated",
    "successDescription": "Share this link with the person you want to invite. The link expires in 5 days.",
    "linkDetails": "Link Details",
    "inviteLink": "Invite Link",
    "tenantRoleLabel": "Tenant Role",
    "clientIdLabel": "Client ID",
    "companyIdLabel": "Company ID",
    "expiresAt": "Expires At",
    "registrationUrl": "Registration URL",
    "copyRegistrationLink": "Copy Registration Link",
    "copyHint": "Copy",
    "copied": "Copied!",
    "copySuccess": "Link copied to clipboard",
    "securityNotice": "Security Notice",
    "securityDescription": "This registration URL will be shown only once. Copy it before closing. Anyone with this URL can register and join with the specified role."
  },
  "tenantRoles": {
    "OWNER": {
      "label": "Owner",
      "description": "Full management rights: employees, configuration and invites"
    },
    "EMPLOYEE": {
      "label": "Employee",
      "description": "Operational access: appointments, leads and resources"
    },
    "CUSTOMER": {
      "label": "Customer",
      "description": "Portal access as a customer of this tenant; no company membership"
    }
  },
  "relativeTime": {
    "justNow": "just now",
    "minutes": "{{count}}m ago",
    "hours": "{{count}}h ago",
    "days": "{{count}}d ago",
    "months": "{{count}}mo ago",
    "years": "{{count}}y ago"
  }
}
